
import React from 'react'
import { FiThumbsUp, FiThumbsDown } from "react-icons/fi" 

export const Thumbs = ({ likes, dislikes }) => {
    const [like] = React.useState(true)
    const [dislike] = React.useState(false);
    return (
        <div className="thumbs">
            <div ><FiThumbsUp className={`${like ? 'up': ''}`} /> {likes}</div>
            <div ><FiThumbsDown className={`${dislike ? 'down': ''}`} /> {dislikes}</div>
        </div>
    )
}